module.exports = __webpack_public_path__ + "vue-app/img/next.a42392fb.svg";